Add choices

@for (choice of componentData.config.choices; track trackByIndex(i, choice); let i = $index) {
  <div class="grid-x grid-margin-x align-top">
    <div class="auto cell">
      <input type="text" [(ngModel)]="componentData.config.choices[i]" [name]="'choice'+i">
    </div>
    <div class="shrink cell">
      <button (click)="removeChoice(i)" attr.aria-label="Delete radio button choice" title="Delete radio button choice">
        <svg-icon icon="icon-trash" class="small medium-gray" aria-hidden="true">
        </svg-icon>
      </button>
    </div>
  </div>
}
<div class="outline-container">
  <button (click)="addBlankChoiceRow()" attr.aria-label="Add radio button choice" title="Add radio button choice">
    <svg-icon icon="icon-plus" class="small medium-gray" aria-hidden="true"></svg-icon>
  </button>
</div>